import { render, staticRenderFns } from "./GoToOrder.vue?vue&type=template&id=7d926763&lang=pug&"
import script from "./GoToOrder.vue?vue&type=script&lang=js&"
export * from "./GoToOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports